import { Action } from '@ngrx/store';
import { Address } from '../../shared/models/b2b/address';
import { SaldoMovimiento } from '../../shared/models/b2b/saldoMovimiento';
import { SaldoDisponible } from '../../shared/models/b2b/saldoDisponible';
import { SearchSettings } from '../../../app/shared/models/b2b/searchSettings';

export enum UserActionsTypes {
    DO_GET_FREQUENT_SEARCH_TERMS = '[User] Do Get Frequent Search Terms',
    DO_GET_FREQUENT_SEARCH_TERMS_OK = '[User] Do Get Frequent Search Terms OK',
    DO_GET_FREQUENT_SEARCH_TERMS_KO = '[User] Do Get Frequent Search Terms KO',
    DO_GET_INFO = '[User] Do Get Info',
    DO_GET_INFO_OK = '[User] Do Get Info OK',
    DO_GET_INFO_KO = '[User] Do Get Info KO',
    DO_GET_ORDERBY = '[User] Do Get OrderBy',
    DO_GET_ORDERBY_OK = '[User] Do Get OrderBy OK',
    DO_GET_ORDERBY_KO = '[User] Do Get OrderBy KO',
    DO_GET_PAYMETHODS = '[User] Do Get PayMethods',
    DO_GET_PAYMETHODS_OK = '[User] Do Get PayMethods OK',
    DO_GET_PAYMETHODS_KO = '[User] Do Get PayMethods KO',
    DO_GET_SETTINGS = '[User] Do Get Settings',
    DO_GET_SETTINGS_OK = '[User] Do Get Settings OK',
    DO_GET_SETTINGS_KO = '[User] Do Get Settings KO',
    DO_GET_ADDRESSES = '[User] Do Get Addresses',
    DO_GET_ADDRESSES_OK = '[User] Do Get Addresses OK',
    DO_GET_ADDRESSES_KO = '[User] Do Get Addresses KO',
    DO_SET_CLIENT = '[User] Do Set Client',
    DO_CLEAR_SETTINGS = '[User] Do Clear Setting',
    DO_GET_BILL = '[User] Do Get Bill',
    DO_GET_BILL_OK = '[User] Do Get Bill OK',
    DO_GET_BILL_KO = '[User] Do Get Bill KO',
    DO_SET_ADDRESSES = '[User] Do Set Addresses',
    DO_SAVE_GIFT_ADDRESS = '[User] Do Save Gift Address',
    DO_SET_SALDO_TOTAL = '[User] Do Set Saldo Total',
    DO_SET_SALDO_MOVIMIENTOS = '[User] Do Set Saldo Movimientos',
    DO_SET_SALDOS_DISPONIBLES = '[User] Do Set Saldos Disponibles',
    DO_SET_USER_SETTINGS = '[User] Do Set User Settings',
}

// User Info
export class DoGetInfo implements Action {
    readonly type = UserActionsTypes.DO_GET_INFO;

    constructor() {}
}

export class DoGetInfoOK implements Action {
    readonly type = UserActionsTypes.DO_GET_INFO_OK;

    constructor(public payload: any) {}
}

export class DoGetInfoKO implements Action {
    readonly type = UserActionsTypes.DO_GET_INFO_KO;

    constructor(public payload: any) {}
}

// User Settings
export class DoGetSettings implements Action {
    readonly type = UserActionsTypes.DO_GET_SETTINGS;

    constructor(public payload: boolean) {}
}

export class DoGetSettingsOK implements Action {
    readonly type = UserActionsTypes.DO_GET_SETTINGS_OK;

    constructor(public payload: any) {}
}

export class DoGetSettingsKO implements Action {
    readonly type = UserActionsTypes.DO_GET_SETTINGS_KO;

    constructor(public payload: any) {}
}

// User Addresses
export class DoGetAddresses implements Action {
    readonly type = UserActionsTypes.DO_GET_ADDRESSES;

    constructor(public payload: any) {}
}

export class DoGetAddressesOK implements Action {
    readonly type = UserActionsTypes.DO_GET_ADDRESSES_OK;

    constructor(public payload: Address[]) {}
}

export class DoGetAddressesKO implements Action {
    readonly type = UserActionsTypes.DO_GET_ADDRESSES_KO;

    constructor(public payload: any) {}
}

// Order By
export class DoGetOrderBy implements Action {
    readonly type = UserActionsTypes.DO_GET_ORDERBY;

    constructor(public payload: string) {}
}

export class DoGetOrderByOK implements Action {
    readonly type = UserActionsTypes.DO_GET_ORDERBY_OK;

    constructor(public payload: any) {}
}

export class DoGetOrderByKO implements Action {
    readonly type = UserActionsTypes.DO_GET_ORDERBY_KO;

    constructor(public payload: any) {}
}

// Frequent Search Terms
export class DoGetFrequentSearchTerms implements Action {
    readonly type = UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS;

    constructor(public payload: any) {}
}

export class DoGetFrequentSearchTermsOK implements Action {
    readonly type = UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS_OK;

    constructor(public payload: any) {}
}

export class DoGetFrequentSearchTermsKO implements Action {
    readonly type = UserActionsTypes.DO_GET_FREQUENT_SEARCH_TERMS_KO;

    constructor(public payload: any) {}
}

// User Payment Methods
export class DoGetPayMethods implements Action {
    readonly type = UserActionsTypes.DO_GET_PAYMETHODS;

    constructor(public payload: any) {}
}

export class DoGetPayMethodsOK implements Action {
    readonly type = UserActionsTypes.DO_GET_PAYMETHODS_OK;

    constructor(public payload: any) {}
}

export class DoGetPayMethodsKO implements Action {
    readonly type = UserActionsTypes.DO_GET_PAYMETHODS_KO;

    constructor(public payload: any) {}
}

// Set Client
export class DoSetClient implements Action {
    readonly type = UserActionsTypes.DO_SET_CLIENT;
    constructor(public payload: any) {}
}

// Set Adresses
export class DoSetAddresses implements Action {
    readonly type = UserActionsTypes.DO_SET_ADDRESSES;

    constructor(public payload: { addresses: Address[]; manualChange?: boolean }) {}
}

// Clear Settings
export class DoClearSettings implements Action {
    readonly type = UserActionsTypes.DO_CLEAR_SETTINGS;

    constructor() {}
}

// User Get Bills
export class DoGetBill implements Action {
    readonly type = UserActionsTypes.DO_GET_BILL;

    constructor(public payload: any) {}
}

export class DoGetBillOK implements Action {
    readonly type = UserActionsTypes.DO_GET_BILL_OK;

    constructor(public payload: any) {}
}

export class DoGetBillKO implements Action {
    readonly type = UserActionsTypes.DO_GET_BILL_KO;

    constructor(public payload: any) {}
}

export class DoSetSaldoTotal implements Action {
    readonly type = UserActionsTypes.DO_SET_SALDO_TOTAL;

    constructor(public payload: number) {}
}

export class DoSetSaldoMovimientos implements Action {
    readonly type = UserActionsTypes.DO_SET_SALDO_MOVIMIENTOS;

    constructor(public payload: SaldoMovimiento[]) {}
}

export class DoSetSaldosDisponibles implements Action {
    readonly type = UserActionsTypes.DO_SET_SALDOS_DISPONIBLES;

    constructor(public payload: SaldoDisponible[]) {}
}

export class DoSaveGiftAddress implements Action {
    readonly type = UserActionsTypes.DO_SAVE_GIFT_ADDRESS;

    constructor(public payload: number) {}
}

export class DoSetUserSettings implements Action {
    readonly type = UserActionsTypes.DO_SET_USER_SETTINGS;
    constructor(public payload: { settings: SearchSettings }) {}
}

export type UserActions =
    | DoGetInfo
    | DoGetInfoOK
    | DoGetInfoKO
    | DoGetSettings
    | DoGetSettingsOK
    | DoGetSettingsKO
    | DoGetOrderBy
    | DoGetOrderByOK
    | DoGetOrderByKO
    | DoGetFrequentSearchTerms
    | DoGetFrequentSearchTermsOK
    | DoGetFrequentSearchTermsKO
    | DoGetPayMethods
    | DoGetPayMethodsOK
    | DoGetPayMethodsKO
    | DoGetAddresses
    | DoGetAddressesOK
    | DoGetAddressesKO
    | DoSetClient
    | DoSetAddresses
    | DoGetBill
    | DoGetBillOK
    | DoGetBillKO
    | DoSetSaldoTotal
    | DoSetSaldoMovimientos
    | DoSaveGiftAddress
    | DoSetUserSettings;
